import { useMemo } from 'react';

function useAllTasksSeries({ systemMessagesHistory, viewedTurnIndex }) {
  return useMemo(() => {
    if (!Array.isArray(systemMessagesHistory) || systemMessagesHistory.length === 0) {
      return { series: [], visibleCount: 0 };
    }

    const latestSeries =
      systemMessagesHistory[systemMessagesHistory.length - 1]?.allTasksSeries || [];

    const turnIndex = viewedTurnIndex === null || viewedTurnIndex === undefined
      ? systemMessagesHistory.length - 1
      : viewedTurnIndex;

    const visibleSeries = systemMessagesHistory[turnIndex]?.allTasksSeries || [];

    return {
      series: latestSeries,
      visibleCount: visibleSeries.length,
    };
  }, [systemMessagesHistory, viewedTurnIndex]);
}

export default useAllTasksSeries;
